module.exports = __webpack_public_path__ + "static/media/fly_anywhere_lg.1ef3ce41.jpg";